
// 资讯埋点数据报表：https://doc.baijia.com/sheets/RTdhVyhHD8vXpkG3/UKEBH

interface StudyInfoEventIdType {
  INFO_ITEM_CLICK: number;
  INFO_MAIN_PAGE_STAY_TIME: number;
  INFO_ARTICLE_SHARE_CLICK: number;
  INFO_ARTICLE_SHARE_CHANNEL: number;
  INFO_ARTICLE_ACC_CLICK: number;
  INFO_ARTICLE_PAGE_STAY_TIME: number;
  INFO_PAGE_PREVIEW: number;
  INFO_PAGE_PROCEED: number;
  COMMENT_INPUT_CLICK: number;
  PUBLISH_BTN_CLICK: number;
  COMMENT_ICON_CLICK: number;
  JOB_BTN_CLICK: number;
  AREA_BTN_CLICK: number;
  USER_TOGGLE_AREA: number;
  CMS_TAG_EXPOSURE: number;
  CMS_TAG_CLICK: number;
  COLLECT_TAB_CLICK: number;
  ARTICLE_COLLECT_BTN: number;
  INFO_PAGE_EXPOSURE: number;
  INFO_REC_CLICK: number;
  INFO_H5_BANNER_SHOW: number;
  INFO_H5_BANNER_CLICK: number;
}

interface SelectInfoEventIdType {
  SELECT_INFO_VIEW: number;
  SELECT_INFO_ITEM_CLICK: number;
  SELECT_INFO_STAY_TIME: number;
}

export interface EventIdType extends StudyInfoEventIdType, SelectInfoEventIdType {}

export const EVENT_ID_MAP: EventIdType = {
  // 资讯-每条资讯的点击
  INFO_ITEM_CLICK: 8992599469156352,
  // 资讯主页停留时长
  INFO_MAIN_PAGE_STAY_TIME: 9053479209822208,
  // 文章分享按钮
  INFO_ARTICLE_SHARE_CLICK: 9053481909905408,
  // 文章分享渠道
  INFO_ARTICLE_SHARE_CHANNEL: 9053484143765504,
  // 文章举报
  INFO_ARTICLE_ACC_CLICK: 9053485569370112,
  // 文章页停留时长
  INFO_ARTICLE_PAGE_STAY_TIME: 9053486938220544,
  // 文章预览
  INFO_PAGE_PREVIEW: 9053491955984384,
  // 点击继续访问
  INFO_PAGE_PROCEED: 9121889548068864,
  // 点击输入框
  COMMENT_INPUT_CLICK: 9313135301715968,
  // 点击发表按钮
  PUBLISH_BTN_CLICK: 9313137359939584,
  // 点击评论 icon
  COMMENT_ICON_CLICK: 9313139058698240,
  // 文章页点击查看岗位按钮
  JOB_BTN_CLICK: 9427717226129408,
  // 列表页用户点击地区筛选
  AREA_BTN_CLICK: 9717142821758976,
  // 用户切换地区
  USER_TOGGLE_AREA: 9717145096316928,
  // 标签曝光
  CMS_TAG_EXPOSURE: 9795366595553280,
  // 标签点击
  CMS_TAG_CLICK: 9795368541710336,
  // 收藏 tab 点击`
  COLLECT_TAB_CLICK: 9795372045395968,
  // 文章页点击收藏按钮
  ARTICLE_COLLECT_BTN: 9795373854189568,
  // 资讯主页曝光
  INFO_PAGE_EXPOSURE: 9840413136218112,
  // 推荐位点击
  INFO_REC_CLICK: 8992599469156352,
  // 精选页
  // 精选页浏览
  SELECT_INFO_VIEW: 10162163232696320,
  // 精选页单条咨询点击(与咨询点击相同)
  SELECT_INFO_ITEM_CLICK: 8992599469156352,
  // 精选页停留时长
  SELECT_INFO_STAY_TIME: 10178516770056192,
  // 资讯H5运营位展示
  INFO_H5_BANNER_SHOW: 13632720743196672,
  // 资讯H5运营位点击
  INFO_H5_BANNER_CLICK: 13632729333458944,
};

// 获取url参数
export function getEventId(eventName: keyof EventIdType): number {
  // 克瑞斯投放页
  return EVENT_ID_MAP[eventName];
}
